import React, { useState, useEffect } from 'react';
import { View, ScrollView, Image, TouchableOpacity, Platform } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../components/Header';
import { CaptionNormalDark, BodyNormalDark, CaptionBoldDark, SubheaderNormalDark, ProgressBar, ComponentSeeAll } from '../../components';
import DoughnutChart from '../../components/DoughnutChart';
import * as Actions from '../../action';
import styles from '../../styles';
import { global } from '../../const';
import ProfileList from '../../components/profile/ProfileList';
import localize from '../../localize';

function FamilyTeam(props) {
    const dispatch = useDispatch();
    const height = useSelector(({ setting }) => setting.height);
    const [state, setState] = useState({
        id: null,
        name: null,
        kind: null,
        progress: [],
        members: [],
        team: [],
    })

    useEffect(() => {       
        let data;
        if (!global.isNative) {
            const query = new URLSearchParams(props.location.search);
            data = props.location.state;
            if (!data) data = { id: query.get('id'), name: query.get('name') }
        } else {
            data = props.navigation.state.params;
        }
        _familyInfo(data)
    }, [global.isNative ? props.navigation.state.params : props.location.state])

    const _familyInfo = async (team) => {
        let response = await dispatch(Actions.getStranth('', team.id))
        if (response[0]) {
            const membersStr = JSON.stringify(response[0].member_ids).slice(1, -1);
            const members = await dispatch(Actions.getWcUsersInfo(membersStr.replace(new RegExp('"', 'g'), '')))
            setState({ ...state, members, progress: response[0], team })
        }
    }

    const _navigation = (pathname, state, search) => {
        if (global.isNative) return props.navigation.navigate(pathname, state)
        props.history.push({
            pathname, state, search
        })
        return;
    }
    const { progress, members, team } = state;
    return (
        <View style={styles.container}>

            {
                !global.isNative && (<Header title={localize.Family_Team} goBack={() => props.history.goBack()} />)
            }
            <ScrollView style={!global.isNative && { height: height - 70 }}>
                <View>

                    <View style={{ justifyContent: "center", marginHorizontal: 10, paddingVertical: 10 }}>
                        <View style={{ alignItems: "center" }}>
                            <CaptionNormalDark title={team.kind === 2 ? localize.Village : localize.Family} />
                            <BodyNormalDark title={team.name} />
                        </View>
                    </View>
                    <View style={styles.divider} />
                </View>

                <View>
                    <View style={{ padding: 20 }}>
                        <View style={{ paddingBottom: 15, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
                            <SubheaderNormalDark title={team.kind === 2 ? localize.Team_Strength : localize.Family_Strength} />
                            <ComponentSeeAll
                                onClick={() => _navigation(Platform.select({ web: '/dashboard/progress', default: 'progress' }), { type: team.kind, id: team.id }, `type=${team.kind}&id=${team.id}`)}
                            />
                        </View>
                        <ProgressBar
                            progress={(progress.strength) / 10 + "%"}
                            start={progress.minLevel}
                            end={progress.maxLevel}
                        />
                    </View>
                    <View style={styles.divider} />
                </View>

                <View style={{ paddingVertical: 10 }}>
                    <DoughnutChart
                        data={progress}
                        title={localize.My_XP}
                    />
                </View>

                <View>
                    <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <View style={{ backgroundColor: "#00c221", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
                            <CaptionBoldDark title={localize.character} />
                        </View>
                        <CaptionNormalDark title={progress.character} />
                    </View>

                    <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <View style={{ backgroundColor: "#5e23ff", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
                            <CaptionBoldDark title={localize.life_experience} />
                        </View>
                        <CaptionNormalDark title={progress.life_experience} />
                    </View>

                    <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <View style={{ backgroundColor: "#ffd000", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
                            <CaptionBoldDark title={localize.financial} />
                        </View>
                        <CaptionNormalDark title={progress.financial} />
                    </View>

                    <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <View style={{ backgroundColor: "#ff0048", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
                            <CaptionBoldDark title={localize.health_wellness} />
                        </View>
                        <CaptionNormalDark title={progress.health} />
                    </View>
                </View>

                <View style={styles.divider} />

                <View>
                    <View style={{ justifyContent: "center", flexDirection: 'row', marginHorizontal: 10, paddingVertical: 10 }}>
                        <View style={{ alignItems: 'center' }}>
                            <CaptionNormalDark title={localize.NUMBER_OF_PLAYERS} />
                            <BodyNormalDark title={members.length} />
                        </View>
                    </View>
                    <View style={styles.divider} />
                </View>
                {members.map((item, i) => <ProfileList data={item} type="user" props={props} key={i} />)}
            </ScrollView>
        </View>
    )

}

FamilyTeam.navigationOptions = () => {
    return {
        title: localize.Family_Team
    }
}

export default FamilyTeam;

// class FamilyTeamas extends Component {

//     constructor(props) {
//         super(props)
//         let data;
//         if (!global.isNative) {
//             const query = new URLSearchParams(props.location.search);
//             data = props.location.state;
//             if (!data) data = { id: query.get('id'), name: query.get('name') }
//         } else {
//             data = props.navigation.state.params;
//         }

//         this.state = {
//             id: null,
//             name: null,
//             kind: null,
//             progress: [],
//             members: [],
//             team: data,
//         }
//     }

//     componentDidMount = async () => {
//         let response = await this.props.getStranth('', this.state.team.id)
//         if (response[0]) {
//             this.setState({ progress: response[0] })
//             return this.getFamilyMember(JSON.stringify(response[0].member_ids).slice(1, -1));
//         }
//     }

//     getFamilyMember = async (members) => {
//         const response = await this.props.getWcUsersInfo(members.replace(new RegExp('"', 'g'), ''));
//         this.setState({ members: response });
//     }

//     _navigation = (pathname, state, search) => {
//         if (global.isNative) return this.props.navigation.navigate(pathname, state)
//         this.props.history.push({
//             pathname, state, search
//         })
//         return;
//     }


//     render() {
//         const { progress, members, team } = this.state;
//         return (
//             <View style={styles.container}>

//                 {
//                     !global.isNative && (<Header title={team.kind === 2 ? "Village Team" : "Family Team"} goBack={() => this.props.history.goBack()} />)
//                 }
//                 <ScrollView style={!global.isNative && { height: this.props.setting.height - 70 }}>
//                     <View>

//                         <View style={{ justifyContent: "center", marginHorizontal: 10, paddingVertical: 10 }}>
//                             <View style={{ alignItems: "center" }}>
//                                 <CaptionNormalDark title={team.kind === 2 ? "Village" : "Family"} />
//                                 <BodyNormalDark title={team.name} />
//                             </View>
//                         </View>
//                         <View style={styles.divider} />
//                     </View>

//                     <View>
//                         <View style={{ padding: 20 }}>
//                             <View style={{ paddingBottom: 15, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
//                                 <SubheaderNormalDark title={team.kind === 2 ? "Team Strength" : "Family Strength"} />
//                                 <ComponentSeeAll
//                                     onClick={() => this._navigation(Platform.select({ web: '/dashboard/progress', default: 'progress' }), { type: team.kind, id: team.id }, `type=${team.kind}&id=${team.id}`)}
//                                 />
//                             </View>
//                             <ProgressBar
//                                 progress={(progress.strength) / 10 + "%"}
//                                 start={progress.minLevel}
//                                 end={progress.maxLevel}
//                             />
//                         </View>
//                         <View style={styles.divider} />
//                     </View>

//                     <View style={{ paddingVertical: 10 }}>
//                         <DoughnutChart
//                             data={progress}
//                             title="My XP"
//                         />
//                     </View>

//                     <View>
//                         <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
//                             <View style={{ flexDirection: 'row', alignItems: 'center' }}>
//                                 <View style={{ backgroundColor: "#00c221", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
//                                 <CaptionBoldDark title="CHARACTER" />
//                             </View>
//                             <CaptionNormalDark title={progress.character} />
//                         </View>

//                         <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
//                             <View style={{ flexDirection: 'row', alignItems: 'center' }}>
//                                 <View style={{ backgroundColor: "#5e23ff", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
//                                 <CaptionBoldDark title="LIFE EXPERIENCE" />
//                             </View>
//                             <CaptionNormalDark title={progress.life_experience} />
//                         </View>

//                         <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
//                             <View style={{ flexDirection: 'row', alignItems: 'center' }}>
//                                 <View style={{ backgroundColor: "#ffd000", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
//                                 <CaptionBoldDark title="FINANCIAL" />
//                             </View>
//                             <CaptionNormalDark title={progress.financial} />
//                         </View>

//                         <View style={[styles.dontChartRow, { paddingHorizontal: 30 }]}>
//                             <View style={{ flexDirection: 'row', alignItems: 'center' }}>
//                                 <View style={{ backgroundColor: "#ff0048", height: 12, width: 18, borderRadius: 4, marginRight: 6 }} />
//                                 <CaptionBoldDark title="HEALTH & WELLNESS" />
//                             </View>
//                             <CaptionNormalDark title={progress.health} />
//                         </View>
//                     </View>

//                     <View style={styles.divider} />

//                     <View>
//                         <View style={{ justifyContent: "center", flexDirection: 'row', marginHorizontal: 10, paddingVertical: 10 }}>
//                             <View style={{ alignItems: 'center' }}>
//                                 <CaptionNormalDark title="NUMBER OF PLAYERS" />
//                                 <BodyNormalDark title={members.length} />
//                             </View>
//                         </View>
//                         <View style={styles.divider} />
//                     </View>
//                     {members.map((item, i) => <ProfileList data={item} type="user" props={this.props} key={i} />)}
//                 </ScrollView>
//             </View>
//         )
//     }

// }

// const mapStateToProps = ({ setting, auth }) => {
//     return {
//         setting: setting,
//         userInfo: auth.userInfo,
//     }
// }
// const mapDispatch = (dispatch) => {
//     return {
//         loader: request => dispatch(loader(request)),
//         getStranth: (user, family, team) => dispatch(getStranth(user, family, team)),
//         getWcUsersInfo: (ids) => dispatch(getWcUsersInfo(ids)),
//     }
// }
// export default connect(mapStateToProps, mapDispatch)(FamilyTeam);